import { render, staticRenderFns } from "./AclsCategories.vue?vue&type=template&id=878f20f0"
import script from "./AclsCategories.vue?vue&type=script&lang=js"
export * from "./AclsCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports